import cls from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./index.module.scss";
import { ComponentType } from "react";

type Props = {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "plain" | "danger";
  size?: "small" | "medium" | "large" | "extra-large";
  loading?: boolean;
  selected?: boolean;
  Icon?: ComponentType<{ className?: string; htmlColor?: string }>;
  iconColor?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({
  className,
  loading,
  Icon,
  iconColor = "#042434",
  disabled,
  selected,
  children,
  variant = "primary",
  size = "small",
  ...rest
}: Props) {
  const buttonClassName = cls(styles.button, "talaera-modern-button", className, {
    [styles.primary]: variant === "primary",
    [styles.secondary]: variant === "secondary",
    [styles.plainButton]: variant === "plain",
    [styles.danger]: variant === "danger",
    [styles.iconButton]: !!Icon,
    [styles.disabled]: disabled,
    [styles.selected]: selected,
    [styles.loading]: loading,
    [styles.small]: size === "small",
    [styles.medium]: size === "medium",
    [styles.large]: size === "large",
    [styles.extraLarge]: size === "extra-large",
  });

  return (
    <button
      className={buttonClassName}
      disabled={disabled || loading}
      type="button"
      {...rest}
    >
      {loading && <CircularProgress style={{ color: "#A0B4C1" }} size={20} />}
      {Icon && <Icon className={styles.icon} htmlColor={iconColor} />}
      {children}
    </button>
  );
}
